var render, staticRenderFns
import script from "./VTabs.vue?vue&type=script&lang=js&"
export * from "./VTabs.vue?vue&type=script&lang=js&"
import style0 from "./VTabs.vue?vue&type=style&index=0&id=e63f8064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63f8064",
  null
  
)

export default component.exports